import { render, staticRenderFns } from "./MarketingFooter.vue?vue&type=template&id=43958d67&scoped=true"
import script from "./MarketingFooter.vue?vue&type=script&lang=js"
export * from "./MarketingFooter.vue?vue&type=script&lang=js"
import style0 from "./MarketingFooter.vue?vue&type=style&index=0&id=43958d67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43958d67",
  null
  
)

export default component.exports